import React from 'react';
import StepPlaceholder from './StepPlaceholder';

const AddOns = () => <StepPlaceholder stepKey="add-ons" />;

export default AddOns;
